import * as t from 'io-ts';
import * as Err from '@fixtuur/error-context';
import { ModelIdData, ModelDerivedData, IOError } from '../base';
import { identity, pipe } from 'fp-ts/function';
import * as E from 'fp-ts/Either';
import * as Arr from 'fp-ts/Array';
import { ModelSummary as DDbModelSummary } from '../dynamoDb';
import { formatValidationErrors } from 'io-ts-reporters';
/** A model summary as returned by this service, excludes files */
export const Data = t.intersection([t.exact(ModelIdData), t.exact(ModelDerivedData)]);
export const fromUnknownDynamoDbModel = (item) => {
    return pipe(item, DDbModelSummary.Data.decode, E.chain(item => Data.decode({
        productId: item.productId,
        articleType: item.articleType,
        kind: item.kind,
        notes: item.notes,
        status: item.status,
        created: item.created,
        lastModified: item.lastModified,
    })), E.mapLeft(formatValidationErrors), E.mapLeft(errorList => Err.construct(IOError.UnableToDecode, {
        errors: JSON.stringify(errorList),
    })));
};
export const arrayFromUnknownDynamoDbModels = (items) => {
    return pipe(items, items => {
        if (Array.isArray(items)) {
            return E.right(items);
        }
        return E.left(Err.construct(IOError.UnableToDecode, {
            error: "expected array but didn't receive one",
            received: JSON.stringify(items, null, 2),
        }));
    }, E.map(Arr.map(fromUnknownDynamoDbModel)), E.map(Arr.partitionMap(identity)));
};
export const fromUnknown = (item) => {
    return pipe(item, Data.decode, E.mapLeft(formatValidationErrors), E.mapLeft(errorList => Err.construct(IOError.UnableToDecode, {
        errors: JSON.stringify(errorList),
    })));
};
export const arrayFromUnknown = (items) => {
    return pipe(items, items => {
        if (Array.isArray(items)) {
            return E.right(items);
        }
        return E.left(Err.construct(IOError.UnableToDecode, {
            error: "expected array but didn't receive one",
            received: JSON.stringify(items, null, 2),
        }));
    }, E.map(Arr.map(fromUnknown)), E.map(Arr.partitionMap(identity)));
};
